import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FilterData, FiltersBar} from './models/filters-bar.model';
import {FormFieldsType} from '../../modals/models/form-actions.model';
import {FormControl, Validators} from '@angular/forms';
import {debounceTime} from 'rxjs/operators';
import {MatSelectChange} from "@angular/material/select";

@Component({
  selector: 'app-filters-bar',
  templateUrl: './filters-bar.component.html',
  styleUrls: ['./filters-bar.component.scss']
})
export class FiltersBarComponent implements OnInit {
  @Input() filters: FiltersBar<any, any>[];
  @Input() cssColContainer: string;
  @Output() filterSelected: EventEmitter<FilterData<any, any>> = new EventEmitter();
  inputFormControl: FormControl = new FormControl('', Validators.minLength(3));
  searchFormControl: FormControl = new FormControl('');
  searchInputDisplay = (value: FilterData<any, any>) => value?.name;
  multiSelectFormControls: {[name: string]: FormControl} = {};
  filterFieldType = FormFieldsType;
  selected: FilterData<any, any>;
  multiSelectedState: FilterData<any, any>[];

  constructor(private cdr: ChangeDetectorRef) {
    this.subscribeToFormControl();
    this.subscribeToSearchFormControl();
  }

  ngOnInit() {
    if (this.filters) {
      this.filters.forEach(filter => {
        if (filter.fieldType == FormFieldsType.Multi_Select) {
          this.multiSelectFormControls[filter.name] = new FormControl('');
        }
      });
      this.setDefaultValueForSingleSelection();
      this.setDefaultValueForMultiSelection();
    }
  }

  // ngOnChanges(changes: NgChanges<FiltersBarComponent>) {
  //   this.setDefaultValueForSingleSelection();
  //   this.setDefaultValueForMultiSelection();
  // }

  subscribeToFormControl() {
    this.subscribeToInputFormControl();
  }

  onSingleSelectionChanged(value: any) {
    this.filterSelected.emit(value);
  }

  onMultiSelectionChanged(event: MatSelectChange) {
    if (!this.multiSelectedState && event?.value) {
      this.multiSelectedState = event.value;
    }
    if (event && event.value && event.value.length > 0 && this.multiSelectFormControl(event.value[0].filterName)) {
      const fakeSelectionItem = event.value.find(filter => filter.isFakeItem);
      const fakeStateItem = this.multiSelectedState.find(filter => filter.isFakeItem);
      if (fakeSelectionItem && event.value.length == this.filters.find(entry => entry.name == event.value[0].filterName)?.data?.length) {
        this.multiSelectFormControl(event.value[0].filterName).setValue([fakeSelectionItem]);
        return;
      }
      if ((fakeSelectionItem !== undefined) || (event.value.length == 1 && event.value[0] == fakeSelectionItem)) {
        this.multiSelectFormControl(event.value[0].filterName).setValue(this.filters.find(entry => entry.name == event.value[0].filterName)?.data?.filter(item => !item.isFakeItem));
        return;
      }
      if (fakeSelectionItem === undefined && fakeStateItem !== undefined) {
        this.multiSelectFormControl(event.value[0].filterName).setValue([]);
      } else {
        if (fakeStateItem !== undefined && event.value.length < this.multiFilter.data.length) {
          if (fakeSelectionItem !== undefined) {
            this.multiSelectFormControl(event.value[0].filterName).setValue(event.value.filter(item => !item.isFakeItem));
          }
        } else {
          if (this.multiFilter.data.length - 1 == event.value.length) {
            this.multiSelectFormControl(event.value[0].filterName).setValue(event.value);
          }
        }
      }
    }
    if (event.value[0]) {
      this.multiSelectedState = this.multiSelectFormControl(event.value[0].filterName)?.value;
    }
  }

  multiSelectFormControl(name: string) {
    return this.multiSelectFormControls[name];
  }

  setDefaultValue(a: FilterData<any, any>, b: FilterData<any, any>) {
    return a.isSelected;
  }

  private subscribeToInputFormControl() {
    this.inputFormControl.valueChanges.pipe(debounceTime(400)).subscribe(changes => {
      if (this.inputFormControl.valid) {
        let inputFilter = this.filters.find(filter => filter.fieldType == FormFieldsType.INPUT);
        let filterData: FilterData<string, string> = {
          id: 1,
          name: inputFilter.name,
          type: inputFilter.fieldType.toString(),
          data: changes,
          filterName: inputFilter.name
        }
        this.filterSelected.emit(filterData);
      }
    });
  }

  private subscribeToSearchFormControl() {
    this.searchFormControl.valueChanges.pipe(
      debounceTime(400)
    ).subscribe(changes => {
      this.filterSelected.emit(changes);
    });
  }

  onOpenChanged(isDropdownOpen: boolean) {
    if (!isDropdownOpen && this.multiFilter) {
      Object.keys(this.multiSelectFormControls).forEach(name => {
        const multiSelectFormControl = this.multiSelectFormControls[name];
        if (multiSelectFormControl && multiSelectFormControl.valid && multiSelectFormControl.value && multiSelectFormControl.value.length > 0) {
          const data = multiSelectFormControl.value;
          let filterData: FilterData<Array<any>, string> = {
            id: 2,
            name: data[0].name,
            type: data[0].type,
            data: data,
            filterName: data[0].filterName
          }
          if (this.multiFilter.fieldType == FormFieldsType.Multi_Select) {
            filterData.data = filterData.data?.map(entry => entry.data);
          }
          this.filterSelected.emit(filterData);
        }
      });
    }
  }

  getFilteredData(filter: FiltersBar<any, any>): FilterData<any, any>[] {
    return filter.searchable && typeof this.searchFormControl.value == 'string' && this.searchFormControl.value && this.searchFormControl.value.length > 0
      ? filter.data.filter(datum => datum.name
        ?.toLowerCase()
        ?.includes(this.searchFormControl.value?.toLowerCase()))
      : filter.data;
  }

  getTriggerValue(filter: FiltersBar<any, any>) {
    return this.multiSelectFormControl(filter.name)?.value ? this.multiSelectFormControl(filter.name).value[0]?.name : '';
  }

  get multiFilter(): FiltersBar<any, any> {
    return this.filters && this.filters.length > 0 && this.filters.find(filter => filter.fieldType == FormFieldsType.Multi_Select) !== undefined ?
      this.filters.find(filter => filter.fieldType == FormFieldsType.Multi_Select)
      : undefined;
  }

  private setDefaultValueForSingleSelection() {
    let changed = false;
    this.filters?.forEach(filter => {
      if (filter.fieldType == FormFieldsType.SELECT) {
        filter.data?.forEach(value => {
          if (value.isSelected) {
            this.onSingleSelectionChanged(value);
          }
        });
      }
    });
  }

  private setDefaultValueForMultiSelection() {
    if (this.multiSelectFormControls) {
      Object.keys(this.multiSelectFormControls).forEach(name => {
        const multiSelectFormControl = this.multiSelectFormControls[name];
        const filter = this.filters.find(f => f.name == name);
        const filterSelectAllOption = filter?.data.find(datum => datum.isSelected && datum.filterName == name);
        if (filterSelectAllOption !== undefined) {
          multiSelectFormControl.setValue(filter?.data?.filter(entry => entry.isSelected && entry.filterName == name));
        }
        this.onOpenChanged(false);
      });
    }
    this.cdr.markForCheck();
  }
}
